import { render, staticRenderFns } from "./datatable-bulk-actions.vue?vue&type=template&id=0b0cf223"
import script from "./datatable-bulk-actions.vue?vue&type=script&lang=js"
export * from "./datatable-bulk-actions.vue?vue&type=script&lang=js"
import style0 from "./datatable-bulk-actions.vue?vue&type=style&index=0&id=0b0cf223&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports